import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.REMOVE_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/removeLocation.js